import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function getInitialLocale() {
  try {
    const saved = localStorage.getItem('lng')
    if (saved) return saved
  } catch (e) {
    // ignore
  }
  // Fallback to browser language (first two letters)
  if (typeof navigator !== 'undefined' && navigator.language) {
    const short = navigator.language.slice(0, 2).toLowerCase()
    if (['en', 'ru'].includes(short)) return short
  }
  return 'en'
}

const messages = {
  en: {
    Login: 'Login',
    'Sign Up': 'Sign Up',
  },
  ru: {
    Login: 'Войти',
    'Sign Up': 'Регистрация',
  },
}

const i18n = new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
})

export default i18n;